import { Controller } from '@hotwired/stimulus'
import store from '../store'

export default class extends Controller {

  connect() {
    this.effects = [
      store.selectedProvision.effect(() => {
        if (store.selectedProvision.value.provisionSqid) {
          this.element.classList.add('has-selected-provision')
        } else {
          this.element.classList.remove('has-selected-provision')
        }
      }),
      store.selectedSectionSqid.effect(() => {
        if (store.selectedSectionSqid.value) {
          this.element.classList.add('has-selected-section')
        } else {
          this.element.classList.remove('has-selected-section')
        }
      }),
    ]
  }

  disconnect() {
    this.effects.forEach(dispose => dispose())
  }
}
